import Link from "next/link";


const EventHead = ({ count }) => {
  return (
    <>
      <div style={{ background: "#0D6EFD" }} className="rbt-page-banner-wrapper">
        <div className="rbt-banner-image"></div>
        <div className="rbt-banner-content">
          <div className="rbt-banner-content-top">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <ul className="page-list">
                    <li style={{ color: "#FFF !important" }} className="rbt-breadcrumb-item">
                      <Link href="/" style={{ color: "#FFF", opacity: 1 }}>Home</Link>
                    </li>
                    <li>
                      <div className="icon-right">
                        <i className="feather-chevron-right"></i>
                      </div>
                    </li>
                    <li style={{ color: "#FFF", opacity: 1 }} className="rbt-breadcrumb-item active">All Event</li>
                  </ul>

                  <div className=" title-wrapper">
                    <h1 style={{ color: "#FFF", opacity: 1 }} className="title mb--0">All Event</h1>
                    <Link href="#" className="rbt-badge-2">
                      <div className="image">🎉</div> {count}{" "}
                      Events
                    </Link>
                  </div>
                  <p style={{ color: "#FFF", opacity: .8 }} className="description">
                  Access, Connect, Collaborate with Partners & Profitable Opportunities through our Events. {" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventHead;
